/**
 * Created with IntelliJ IDEA.
 * User: danielr
 * Date: 5/8/13
 * Time: 3:13 PM
 * To change this template use File | Settings | File Templates.
 *
 * The view which renders the items (buttons)
 */
define(function (require) {
    "use strict";

    var Marionette = require('marionette');
    var Logger = require('logger');
    var template = require('ui/single-select/templates/singleSelectItems.tmpl');
    var $ = require("jquery");


    var SingleSelectItemsView = Marionette.ItemView.extend({
        template:template,
        tagName: "li",
        className: "category-item", //!!! DO NOT REMOVE THIS. IF CLASSNAME NOT DEFINED, EVENTS ARE NOT TRIGGERED

        // event handlers
        events:{
            "click .category-item-button":"onItemClick" //button click
        },

        ui:{
            button: ".category-item-button"
        },

        initialize:function (options) {
            this.logger = Logger.getLogger('SingleSelect');
            this.vent = options.vent;
            this.selectedItems = options.selectedItems;
        },

        onItemClick: function(){
            this.logger.info("SingleSelectItemsView::OnItemClick::" + this.model.get("name") + " has been clicked!","SingleSelectItemsView:onItemClick");

            //trigger event only if the button is not disabled
            if (!this.model.get("isDisabled")){
                //this.ui.button.addClass("selected");
                this.vent.trigger("set:selection", { item: this.model, activeButton: this.ui.button });
            }
        },

        onRender: function() {
            //add the disabled class if the item is disabled
            //this.ui.button.removeClass("selected");
            if (this.model.get("isDisabled")){
                this.ui.button.addClass("disabled");
            }
            if ($.inArray(this.model.id, this.selectedItems) > -1){
                this.ui.button.addClass("selected");
            }
        }
    });

    return SingleSelectItemsView;
});

